<template>
    <div class="card mb-3 p-2">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="d-flex align-items-center">
                    <h5 class="me-2 mb-0">Evaluation&nbsp;Date</h5>
                    <date-picker 
                        v-model="activeDatePicker" 
                        value-type="date"
                        :clearable="false"
                        :formatter="formatter"
                    ></date-picker>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-8">
                <div class="row">
                    <div v-for="d in sortedDates" class="col-4 col-md-4 col-lg-2">
                        <button
                        @click="setActive(d.evaluation_date)" 
                        class="btn btn-sm col-12 my-1"
                        :class="activeDate == d.evaluation_date ? 'btn-primary' : 'btn-outline-primary'"
                        ><i class="far fa-calendar me-1"></i>{{ formatDate(d.evaluation_date) }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import { DateTime } from "luxon";

export default {
    components: { DatePicker },

    props: {
        dates: {
            type: Array,
            default: [],
        },

        value: {
            type: String,
            default: '',
        },
    },

    computed: {
        activeDatePicker: {
            get: function() {
                return DateTime.fromSQL(this.activeDate).startOf('day').toJSDate();
            },

            set: function(val) {
                this.activeDate = DateTime.fromJSDate(val).startOf('day').toSQLDate();
            }
        },

        sortedDates: function() {
            return this.dates.sort(this.sorter);
        }

    },

    methods: {
        /**
         * Converts SQL date (YYYY-MM-DD) to locale string
         * 
         * @param (string) date 
         */
        formatDate: function(date_sql) {
            return DateTime.fromSQL(date_sql).startOf('day').toLocaleString(DateTime.DATE_SHORT);
        },

        setActive: function(date_local) {
            this.activeDate = DateTime.fromSQL(date_local).startOf('day').toSQLDate();
        },

        sorter: function(a, b) {
            a = DateTime.fromSQL(a.evaluation_date);
            b = DateTime.fromSQL(b.evaluation_date);
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
        }
    },

    watch: {
        activeDate: function(n, o) {
            this.$emit('input', n);
        },
    },

    data() {
        return {
            formatter: {
                stringify: (date) => {
                    return DateTime.fromJSDate(date).startOf('day').toLocaleString(DateTime.DATE_SHORT);
                },
            },
            activeDate: this.value,
        }
    }


}
</script>

<style scoped>
a[active='1'] {
    font-weight: bold;
}
</style>